<template>
  <Transition name="slide">
    <AppDataFilter
      v-if="isOpened"
      :id="filterId"
      :filter-groups="filterGroups"
      :value="filterValues"
      @close="handleClose"
      @update="onUpdate"
    >
      <template #bottom-content>
        <Component v-if="bottomContent" :is="bottomContent" />
      </template>
    </AppDataFilter>
  </Transition>
</template>

<script>
import AppDataFilter from './AppDataFilter';

export default {
  name: 'AppDataFilterMain',
  components: { AppDataFilter },

  props: {
    filterId: {
      type: String,
      default: 'dataFilter',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    filterGroups() {
      return this.$store.state.filter.groups
        .map((group) => {
          if (!group.dependOn) {
            return group;
          }

          const items = group.items.filter((item) =>
            item.dependOn?.value ? this.filterValues[group.dependOn].includes(item.dependOn.value) : false
          );

          return {
            ...group,
            items,
          };
        })
        .filter((group) => !Array.isArray(group.items) || group.items.length);
    },
    filterValues() {
      return this.$store.state.filter.values;
    },
    isOpened() {
      return this.$store.state.filter.isOpened;
    },
    bottomContent() {
      const name = this.$store.state.filter.bottomContent.componentName;
      if (!name) {
        return null;
      }

      return () => import(`@/components/${name}.vue`);
    },
  },

  watch: {
    isOpened: {
      handler(opened) {
        if (opened) {
          this.handleOpen();
        } else {
          this.handleClose();
        }
      },
      immediate: true,
    },
  },

  methods: {
    handleOpen() {
      if (this.isMobile) {
        this.$store.dispatch('disableScroll');
      }
      this.$emit('open');
    },
    handleClose() {
      if (!this.isOpened) {
        return;
      }

      if (this.isMobile) {
        this.$store.dispatch('enableScroll');
      }
      this.$store.dispatch('filter/toggleFilter', false);
      this.$emit('close');
    },
    onUpdate({ itemsType, values }) {
      const childrenGroup = this.filterGroups.find(
        (group) => group.type === 'checkbox' && group.dependOn === itemsType
      );
      const newValues = {
        [itemsType]: values,
      };

      if (childrenGroup && this.filterValues[childrenGroup.itemsType]?.length) {
        newValues[childrenGroup.itemsType] = childrenGroup.items
          .filter(
            (item) =>
              this.filterValues[childrenGroup.itemsType].includes(item.value) && values.includes(item.dependOn?.value)
          )
          .map((item) => item.value);
      }

      this.$store.dispatch('filter/setValues', { ...this.filterValues, ...newValues });
    },
  },
};
</script>
